import {
    ARTICLE_IS_DRAFT,
} from 'mk/autogenerated/translations/ArticleEdit.8fc59079aec3d02cfbf164c9c0644522'
import { canEditWiki, canManageBlogs, isAuthenticatedAsAmbassador } from 'mk/bazaar/common/userUtils';
import { ArticleCreateEditForm, ArticleFormData } from 'mk2/apps/blogs/components/ArticleCreateEditForm';
import { Props } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEditPage';
import { getArticleIsDraftLabelBasedOnAdvancedArticleCategory } from 'mk2/apps/blogs/utils';
import { SmartTextareaEditorType } from 'mk2/components/forms/SmartTextareaField';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import React from 'react';
import styles from './ArticleEdit.mscss';

export default class ArticleEdit extends React.Component<Props> {

    public render() {
        const { loadingState, articlePost } = this.props;
        return (
            <div className={styles.ArticleEdit}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={!!articlePost}
                />
            </div>
        );
    }

    private load = () => {
        // disable load during SSR
        if (typeof window !== 'undefined') {
            const { match: { params: { username, articleSlug } }, onLoad} = this.props;
            onLoad(username, articleSlug);
        }
    };

    private renderLoadSuccess = () => {
        const {
            articlePost, currentValues, disableEditorTypeChange, initialValues, isMobile, isUploadingPhotos,
            isConvertingBody, onPrepareUploadPhotosCustom, requestUser, requestUserPermissions,
        } = this.props;

        const busy = !articlePost || isUploadingPhotos || isConvertingBody;

        const isWikiAdmin = canEditWiki(requestUserPermissions);
        const isBlogsAdmin = canManageBlogs(requestUserPermissions);
        const isAmbassador = isAuthenticatedAsAmbassador(requestUser);

        return (
            <div className={styles.ArticleEdit}>
                {articlePost && !articlePost.isPublished && (
                    <div className={styles.ArticleEdit__draft}>
                        {getArticleIsDraftLabelBasedOnAdvancedArticleCategory(articlePost)}
                    </div>
                )}
                <ArticleCreateEditForm
                    isEdit
                    requestUser={requestUser}
                    requestUserPermissions={requestUserPermissions}
                    isMobile={isMobile}
                    onSave={!busy && this.handleOnSave}
                    onEditorTypeChange={!busy && this.handleOnEditorTypeChange}
                    allowEditorTypeChange={(isBlogsAdmin || isWikiAdmin || isAmbassador) && !disableEditorTypeChange}
                    initialValues={initialValues}
                    currentValues={currentValues}
                    onPrepareUploadPhotosCustom={onPrepareUploadPhotosCustom}
                    articlePost={articlePost}
                />
            </div>
        );
    };

    private handleOnEditorTypeChange = (editorType: SmartTextareaEditorType) => {
        const { onEditorTypeChange, articlePost } = this.props;
        onEditorTypeChange(articlePost.user.username, articlePost.slug, editorType);
    };

    private handleOnSave = (values: ArticleFormData) => {
        const { onSaveAndPublish, currentValues, articlePost } = this.props;
        onSaveAndPublish(articlePost.user.username, articlePost.slug, articlePost.id, currentValues);
    };

}
